import { FailureCard } from "@/shared/components/FailureCard";

export function NotFoundPage() {
  return (
    <div className="py-12">
      <FailureCard
        title="There is nothing at this address"
        description="The link may be old, or the item was removed. The overview is the best place to start again."
        details={`404 · ${window.location.pathname}`}
      />
    </div>
  );
}
